import Flux from '../flux/Flux';
import LegalTexts from './LegalTexts';

export default function TermsOfService() {
	return <LegalTexts type={Flux.Constants.Legal.Types.GTC} download />;
}
